import { merge } from '@/helpers/Utility';
import { FC, ReactNode } from 'react';
import { InputProps, withField } from '../withField';
import { CheckboxInput } from './Checkbox';

export interface MultiCheckboxOption {
  id: number | string;
  suffix?: string | ReactNode;
  prefix?: string | ReactNode;
}

export interface MultiCheckboxProps {
  checkboxes: MultiCheckboxOption[];
  className?: string;
}

export const MultiCheckboxInput: FC<InputProps<(number | string)[]> & MultiCheckboxProps> = ({
  checkboxes,
  className,
  value = [],
  onChange
}) => {
  const handleChange = (id: number | string, checked: boolean) => {
    if (checked) {
      onChange([...value, id]);
    } else {
      onChange(value.filter(v => v !== id));
    }
  };

  return (
    <div className={merge('flex flex-col gap-2', className)}>
      {checkboxes.map(checkbox => (
        <CheckboxInput
          key={checkbox.id.toString()}
          id={checkbox.id.toString()}
          value={value.includes(checkbox.id)}
          onChange={checked => handleChange(checkbox.id, checked)}
          suffix={checkbox.suffix}
          prefix={checkbox.prefix}
        />
      ))}
    </div>
  );
};

export const MultiCheckboxField = withField<(number | string)[], MultiCheckboxProps>(MultiCheckboxInput);
